@if (type() === 'datetime' || type() === 'date') {
  <app-datepicker-dropdown
    #inputElement
    [window]="range()"
    [actualValue]="getDateTimeValue()"
    [type]="$any(type())"
    (updatedValue)="onDateSelected($event)" />
} @else {
  <app-timepicker-dropdown
    #inputElement
    [window]="range()"
    (updatedValue)="onTimeSelected($event)"
    [actualValue]="getTimeValue()" />
}
